<template>
  <div class="registration-uf-list">
    <div v-for="(uf, i) in ufs"
         :class="`txt-${module}`"
         :key="`sheet-module-${module}-uf-${i}`">
      <strong>{{ uf.name }}</strong>
      <small>
        ({{ units[year].findFromIndex(uf.ufType).code }})
      </small>
    </div>
  </div>
</template>
<script>
import units from '@/sui/data/units'

export default {
  name: 'registration-uf-list',

  props: {
    ufs: {
      type: Array,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    year: {
      type: String,
      required: true
    }
  },

  computed: {
    units: function () {
      return units
    }
  }
}
</script>
<style scoped lang="less">
</style>
